import { GoogleTagManager } from '@iwoca/frontend-tracking-library';
import _ from 'lodash';
import { fork, put, select, takeLatest } from 'redux-saga/effects';

import * as actions from './AccountCreatedNotification.actions';
import {
    getCountryCode,
    isIntroducer,
    missingRequiredApplicationDetails as missingRequiredApplicationDetailsSelector
} from '../../lendingAPI/lendingAPISelector';
import { CLOSE_MODAL, OPEN_MODAL } from '../Modals/Modals.actions';

function* accountCreatedNotificationSaga() {
    yield takeLatest(actions.CHECK_ACCOUNT_CREATED, function* ({ payload }) {
        const { missingRequiredApplicationDetails, countryCode, isBroker } =
            yield select((state) => ({
                missingRequiredApplicationDetails:
                    missingRequiredApplicationDetailsSelector(state),
                countryCode: getCountryCode(state),
                isBroker: isIntroducer(state)
            }));
        const apiUIState = _.get(payload, 'customerState.ui', {});
        if (
            !missingRequiredApplicationDetails &&
            !apiUIState.activeStep &&
            !apiUIState.hasSeenAccountCreatedModal &&
            !isBroker &&
            countryCode === 'uk'
        ) {
            yield put({
                type: OPEN_MODAL,
                modalId: 'accountCreatedNotification'
            });
        }
    });
}

function* recogniseAccountCreatedNotificationModalSaga() {
    yield takeLatest(
        actions.RECOGNISE_ACCOUNT_CREATED_NOTIFICATION,
        function* () {
            GoogleTagManager.trackClick({
                identifier: 'Acknowledged account created'
            });
            yield put({ type: actions.CLOSE_ACCOUNT_CREATED_NOTIFICATION });
        }
    );
}

function* closeAccountCreatedNotificationModalSaga() {
    yield takeLatest(actions.CLOSE_ACCOUNT_CREATED_NOTIFICATION, function* () {
        const { application, ui } = yield select((state) => ({
            application: state.fetched.application.payload,
            ui: state.ui
        }));

        yield put({
            type: 'SAVE_CUSTOMER_STATE_REQUESTED',
            state: {
                data: {
                    application,
                    ui: _.merge({}, ui, {
                        hasSeenAccountCreatedModal: new Date().toISOString()
                    })
                }
            }
        });
        yield put({ type: CLOSE_MODAL });
    });
}

export default [
    fork(accountCreatedNotificationSaga),
    fork(closeAccountCreatedNotificationModalSaga),
    fork(recogniseAccountCreatedNotificationModalSaga)
];
